import "regenerator-runtime/runtime";
import _asyncToGenerator from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.number.constructor";
import VImage from '@/components/base/VImage/VImage.vue';
export default {
  props: {
    type: {
      type: String,
      default: 'normal'
    },
    isBorderRadius: {
      type: Boolean,
      default: true
    },
    src: {
      type: String,
      default: '//placehold.it/336x188'
    },
    item: {
      type: Object,
      required: true
    },
    visible: {
      type: Number,
      default: 0
    },
    hasLayer: {
      type: Boolean,
      default: false
    },
    triggerDefault: {
      type: Boolean,
      default: true
    },
    autoDownload: {
      type: Boolean,
      default: true
    },
    fromOpenMod: {
      type: Boolean,
      default: false
    },
    stopClick: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    click: function () {
      var _click = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var judge;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!this.stopClick) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                if (!this.fromOpenMod) {
                  _context.next = 5;
                  break;
                }
                this.openH5();
                return _context.abrupt("return");
              case 5:
                _context.next = 7;
                return this.checkVipStatus(this.visible);
              case 7:
                judge = _context.sent;
                if (judge) {
                  _context.next = 10;
                  break;
                }
                return _context.abrupt("return");
              case 10:
                this.openH5();
              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
      function click() {
        return _click.apply(this, arguments);
      }
      return click;
    }(),
    openH5: function openH5() {
      if (this.triggerDefault) {
        if (this.item && this.item.tActType.sActType !== 'welfare') {
          this.openUrl(this.item.tActType.sH5Url);
        }
      }
    }
  },
  computed: {
    imgFromData: function imgFromData() {
      switch (this.type) {
        case 'normal':
          return this.item.tPicList.mpList.pic_600x336;
        case 'bar':
          return this.item.tPicList.mpList.pic_702x194;
        case 'vertical':
          return this.item.tPicList.mpList.pic_218x300;
        case 'square':
          return this.item.tPicList.mpList.pic_218x218;
      }
    },
    imgSrc: function imgSrc() {
      if (this.item) {
        return this.imgFromData;
      } else {
        return this.src;
      }
    }
  },
  components: {
    VImage: VImage
  }
};